// material design
import Box from "@mui/material/Box";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

// entzy config and models
import configEntzy from "components/config/ConfigEntzy";
import { createMainMenuList } from "models/main";
import { createGeoCountryList } from "models/geo";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignIn as iconLogin } from "@fortawesome/pro-duotone-svg-icons";
import { faBars as iconMenu } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-duotone-svg-icons";

function MenuBox(props) {
  const menuUser = props.user;
  const menuSelected = props.menuSelected;
  const menuFullList = createMainMenuList().filter((obj) => !obj.bookend);
  const countryList = createGeoCountryList();

  return (
    <Box
      className="box-default bg-black-t50"
      sx={{ p: configEntzy.APP_SPACING_MD, color: "white" }}
    >
      <Box className="box-default half-width text-left">
        <Typography variant="h6" noWrap>
          <span
            className="action-pointer"
            onClick={() => props.drawerMenuToggle(false)}
          >
            <FontAwesomeIcon icon={iconMenu} />
            &nbsp;&nbsp;MENU
          </span>
        </Typography>
      </Box>
      <Box className="box-default half-width text-right">
        <Typography variant="h6" noWrap>
          <span
            className="action-pointer"
            onClick={() => props.drawerMenuToggle(false)}
          >
            <FontAwesomeIcon icon={iconClose} transform="grow-4" />
          </span>
        </Typography>
      </Box>

      <Box
        className="box-default"
        sx={{
          textAlign: "left",
          mt: configEntzy.APP_SPACING_MD,
        }}
      >
        <MenuList variant="selectedMenu">
          {menuFullList.map(function (item, index) {
            return (
              <Box
                key={item.id}
                className="box-default"
                hidden={
                  (item.connected && !menuUser.connected) ||
                  (item.admin && !menuUser.admin)
                }
              >
                {item.titleOnly ? (
                  <Box className="box-default">
                    <Box
                      key={item.id}
                      className="box-default content-disabled"
                      sx={{
                        mt: configEntzy.APP_SPACING_LG,
                        pb: configEntzy.APP_SPACING_MD,
                      }}
                    >
                      <ListItemText>
                        <Typography variant="h6">
                          &nbsp;&nbsp;{item.name}
                        </Typography>
                      </ListItemText>
                    </Box>
                    <Divider />
                  </Box>
                ) : (
                  <MenuItem
                    key={item.id}
                    divider={true}
                    sx={{
                      pt: configEntzy.APP_SPACING_MD,
                      pb: configEntzy.APP_SPACING_MD,
                      pl: item.parent
                        ? configEntzy.APP_SPACING_MD
                        : configEntzy.APP_SPACING_LG,
                    }}
                    onClick={() => props.menuSelect(item)}
                    selected={menuSelected && menuSelected.id === item.id}
                  >
                    <ListItemIcon>
                      <Typography variant="subtitle2">
                        <FontAwesomeIcon
                          icon={item.icon}
                          transform="grow-10 left-5"
                        />
                      </Typography>
                    </ListItemIcon>
                    <ListItemText>
                      <Typography variant="subtitle2">
                        <span className="proper-case">{item.name}</span>
                      </Typography>
                    </ListItemText>
                  </MenuItem>
                )}
              </Box>
            );
          })}
        </MenuList>
      </Box>
      <Box
        className="box-default text-left"
        sx={{
          pt: configEntzy.APP_SPACING_XL,
          pl: configEntzy.APP_SPACING_MD,
        }}
      >
        <Box className="box-default">
          <Typography variant="subtitle1">
            BACKDROPS&nbsp;&nbsp;&nbsp;✨
          </Typography>
        </Box>
        <Box className="box-default">
          {Array.from(Array(configEntzy.BACKDROP_COUNT).keys()).map(function (
            n,
          ) {
            return (
              <Box
                key={"backdrop" + n}
                className={"box-default action-pointer backdrop drip" + (n + 1)}
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                  mb: configEntzy.APP_SPACING_MD,
                  mr: configEntzy.APP_SPACING_MD,
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  display: "inline-block",
                  boxShadow:
                    props.backdropActive === "backdrop drip" + (n + 1)
                      ? "0 0 0 3px #fff"
                      : "inset 0 0 0 3px #000",
                  overflow: "hidden",
                }}
                onClick={() => {
                  props.setBackdrop(n + 1);
                  props.drawerMenuToggle(false);
                }}
              >
                <Box
                  className="box-default bg-black-t50"
                  sx={{
                    width: "38px",
                    height: "38px",
                    margin: "6px",
                    borderRadius: "50%",
                  }}
                ></Box>
              </Box>
            );
          })}
        </Box>
        {/* flags attribution from https://flagpedia.net/ */}
        <Box className="box-default" sx={{ mt: configEntzy.APP_SPACING_LG }}>
          <Typography variant="subtitle1">
            FLAG BACKDROPS&nbsp;&nbsp;&nbsp;✨
          </Typography>
        </Box>
        <Box className="box-default">
          {countryList.map(function (country) {
            return (
              <Box
                key={"backdrop-flag-" + country.id}
                className="box-default action-pointer"
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                  mb: configEntzy.APP_SPACING_MD,
                  mr: configEntzy.APP_SPACING_MD,
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  display: "inline-block",
                  boxShadow:
                    props.backdropActive === "flag-" + country.code.short
                      ? "0 0 0 3px #fff"
                      : "inset 0 0 0 3px #000",
                  overflow: "hidden",
                  backgroundImage: `url(/images/flags/${country.code.short.toLowerCase()}.png)`,
                  backgroundSize: "cover",
                }}
                onClick={() => {
                  props.setBackdrop("flag-" + country.code.short);
                  props.drawerMenuToggle(false);
                }}
              >
                <Box
                  className="box-default bg-black-t50"
                  sx={{
                    width: "38px",
                    height: "38px",
                    margin: "6px",
                    borderRadius: "50%",
                  }}
                ></Box>
              </Box>
            );
          })}
        </Box>
      </Box>
      {!menuUser.connected && (
        <Box
          className="box-default"
          sx={{
            mt: configEntzy.APP_SPACING_XL,
            mb: configEntzy.APP_SPACING_XL,
          }}
        >
          <Typography
            variant="subtitle1"
            onClick={() => {
              props.drawerMenuToggle(false);
              props.drawerConnectToggle(true);
            }}
          >
            <em>
              <span
                className="shadow-light rounded action-pointer"
                style={{ padding: "16px" }}
              >
                <span>Connect to access all services</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span>
                  <FontAwesomeIcon icon={iconLogin} transform="grow-5" />
                </span>
              </span>
            </em>
          </Typography>
        </Box>
      )}
      <Box
        className="box-default text-left"
        sx={{
          pt: configEntzy.APP_SPACING_XL,
          pl: configEntzy.APP_SPACING_MD,
        }}
      >
        <Typography variant="subtitle1">
          <span
            className="action-pointer"
            onClick={() => {
              props.drawerMenuToggle(false);
              props.navigate("/legal/terms");
            }}
          >
            TERMS
          </span>
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            mt: configEntzy.APP_SPACING_MD,
          }}
        >
          <span
            className="action-pointer"
            onClick={() => {
              props.drawerMenuToggle(false);
              props.navigate("/legal/privacy");
            }}
          >
            PRIVACY
          </span>
        </Typography>
      </Box>
      <Box
        className="box-default text-left"
        sx={{
          pt: configEntzy.APP_SPACING_LG,
          pl: configEntzy.APP_SPACING_MD,
          pr: configEntzy.APP_SPACING_MD,
        }}
      >
        <Typography variant="subtitle1" color="primary">
          &copy; ENTZY {new Date().getFullYear()}
          <span
            style={{
              float: "right",
              color: "#ccc",
            }}
          >
            <span>&nbsp;&nbsp;</span>
            <span>{configEntzy.APP_CONTINENT}</span>
          </span>
          {configEntzy.APP_ENV !== "production" && (
            <span
              style={{
                float: "right",
                color: "#ccc",
              }}
            >
              <span>&nbsp;&nbsp;</span>
              <span>{configEntzy.APP_VERSION}</span>
            </span>
          )}
        </Typography>
      </Box>
    </Box>
  );
}

export default MenuBox;
